module.exports = __webpack_public_path__ + "static/img/logo-white.83050bb.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-white.svg
// module id = 239
// module chunks = 32